(function () {
  function activateCollectionLinks() {
    var links = document.querySelectorAll(".collection-card");
    if (!links.length) return;

    var currentPath = window.location.pathname.replace(/\/+$/, "");
    links.forEach(function (link) {
      var linkPath = new URL(link.href, window.location.origin).pathname.replace(/\/+$/, "");

      if (currentPath !== linkPath) return;

      link.classList.add("active");
      link.setAttribute("aria-current", "page");

      try {
        link.scrollIntoView({ inline: "center", block: "nearest", behavior: "smooth" });
      } catch (e) {}
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", activateCollectionLinks, { once: true });
  } else {
    activateCollectionLinks();
  }

  document.addEventListener("shopify:section:load", activateCollectionLinks);
})();
